<template>
  <div class="scroll overflow-touch overflow-y-auto overflow-x-hidden" ref="scroll" @scroll.passive="scroll">
    <slot></slot>
  </div>
</template>

<script>
/**
 * event
 * @event scroll
 * @event scrollEnd
 */
import animate from '../lib/animate'

export default {
  name: "v-scroll",
  data() {
    return {
      scrollEL: {},
      children: [],
      y: 0,
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      const el = this.$refs.scroll;
      if (!el) {
        setTimeout(this.init, 20);
      } else this.scrollEL = el;
    },
    scroll($event) {
      const el = $event.target;
      this.$emit('scroll', {top: el.scrollTop, height: el.clientHeight, scrollHeight: el.scrollHeight});
      this.y = el.scrollTop;
      console.log(el.clientHeight, el.scrollTop, el.scrollHeight);
      if (Math.abs(el.clientHeight + el.scrollTop - el.scrollHeight) <= 1) {
        this.$emit('scrollEnd', {top: el.scrollTop});
      }
    },
    scrollToTop() {
      this.scrollEL.scrollTop = 0;
    },
    scrollToBottom() {
      Log('y', this.scrollEL.scrollHeight);
      this.scrollEL.scrollTop = this.scrollEL.scrollHeight;
    },
    scrollToElement(el, delta = 0) {
      this.initChildren();
      if (el) {
        let stop = el.getBoundingClientRect().top - 45 - delta,
          oldTop = this.scrollEL.scrollTop;
        Log('stop', stop);
        (stop > 1 || stop < -1) && (this.tween(0, oldTop, stop));
      }
    },

    tween(t, b, c, duration = 200) {
      t += 10;
      if (t <= duration) {
        let top = animate.sineaseOut(t, b, c, duration);
        Log('top', top);
        this.scrollEL.scrollTop = top;
        setTimeout(() => {
          this.tween(t, b, c, duration);
        }, 10)
      }
    },

    initChildren() {
      if (this.children.length === 0) {
        const nodes = this.scrollEL.childNodes;
        let top = 0;
        Array.prototype.forEach.call(nodes, (r) => {
          if (r.nodeType === 1) {
            this.children.push({el: r, height: r.clientHeight, top: top});
            top += r.clientHeight;
          }
        });
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/plugins/v-scroll.vue